import React from 'react';
import '../Colors.css';

const Search = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='HslBlue' d="M914.563 1006.479l-260.328-260.324 91.927-91.931 260.328 260.328c25.371 25.371 25.371 66.503 0 91.873l-0.054 0.054c-25.367 25.371-66.503 25.371-91.873 0z"/>
      <path className='HslBlue' d="M437.528 130.007c169.564 0 307.514 137.951 307.514 307.514 0 169.56-137.951 307.511-307.514 307.511s-307.514-137.951-307.514-307.511c0-169.564 137.951-307.514 307.514-307.514zM437.528 0c-241.637 0-437.521 195.884-437.521 437.521s195.884 437.517 437.521 437.517 437.521-195.881 437.521-437.517-195.884-437.521-437.521-437.521v0z"/>
    </svg>
  );
};

export default Search;